  import { useMutation } from '@tanstack/react-query'
  import { createReport } from '@/services/modules/atlas/reports/reports'
  import { handleToast } from '@/utils/handleToast'
  import { ReportData } from '@/pages/DemandReports/Header/ReportDialog'

  interface ReportPayload {
    demandId: string
    reportData: ReportData
  }

  export function useReportDemand({ onSuccess }: { onSuccess: () => void }) {
    const mutation = useMutation({
      mutationFn: ({ demandId, reportData }: ReportPayload) =>
        createReport(demandId, reportData),

      onSuccess: () => {
        onSuccess()
        handleToast({
          type: 'success',
          message: 'Requisição realizada com sucesso.'
        })
      },
      onError: () =>
        handleToast({
          type: 'error',
          message: 'Ocorreu um erro na solicitação. Tente novamente.'
        })
    })

    return {
      reportDemandMutate: mutation.mutate,
      isReportDemandLoading: mutation.isLoading
    }
  }
